import React from 'react';

// Tokeny motywu zamiast bialego tekstu na polprzezroczystym tle (bialy tekst
// byl niewidoczny w jasnym motywie, gdy motyw przestal wymuszac tlo przyciskow)
const tabBtnStyle = (isActive) => ({
  padding: '6px 12px',
  fontSize: '12px',
  fontWeight: isActive ? '600' : '500',
  cursor: 'pointer',
  border: isActive ? '1px solid var(--success)' : '1px solid var(--border)',
  backgroundColor: isActive ? 'var(--success)' : 'var(--card-bg)',
  color: isActive ? '#fff' : 'var(--text-secondary)'
});

const tabs = [
  { key: 'inventory', label: '📦 Magazyn', permission: 'canViewStock' },
  { key: 'external-receipt', label: '📥 PZ', permission: 'canReceive' },
  { key: 'internal-receipt', label: '📦 PW', permission: 'canReceive' },
  { key: 'internal-issue', label: '📤 RW', permission: 'canIssue' },
  { key: 'external-issue', label: '📦 WZ', permission: 'canIssue' },
  { key: 'inventory-check', label: '📋 Inwentaryzacja', permission: 'canInventory' },
  { key: 'transfers', label: '🔄 Transfery', permission: 'canTransfer' },
  { key: 'stats', label: '📊 Statystyki', permission: 'canViewStock' },
];

const WarehouseHeader = ({
  activeTab, setActiveTab, loading, selectedLocation,
  permissions, onRefresh
}) => (
  <div style={{
    border: '1px solid var(--purple)', color: 'var(--purple)' ,
    padding: '0.5rem 1rem', marginBottom: '0.75rem', borderRadius: '0.375rem',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  }}>
    <div>
      <h5 style={{ margin: 0, fontSize: '14px', fontWeight: '600' }}>📦 Magazyn</h5>
      <div style={{ fontSize: '10px', opacity: 0.9 }}>
        {selectedLocation ? `📍 ${selectedLocation.nazwa || selectedLocation.name}` : 'Wybierz lokalizację'} | {new Date().toLocaleDateString()}
      </div>
    </div>

    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
      {tabs.map(tab => (
        permissions[tab.permission] && (
          <button
            key={tab.key}
            style={tabBtnStyle(activeTab === tab.key)}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        )
      ))}
      <button
        style={{
          padding: '6px 12px', fontSize: '12px', fontWeight: '500',
          border: '1px solid var(--border)',
          cursor: loading ? 'not-allowed' : 'pointer',
          backgroundColor: 'var(--card-bg)', color: 'var(--text-secondary)',
          opacity: loading ? 0.7 : 1
        }}
        onClick={onRefresh}
        disabled={loading}
      >
        🔄 {loading ? '...' : 'Odśwież'}
      </button>
    </div>
  </div>
);

export default WarehouseHeader;
